/**
 * @generated SignedSource<<42121bde236476b0bd952b4989ea8e58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type changeJiraRemainingSyncInput = {
  forecastProjectId?: string | null;
  syncRemaining?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ChangeJiraRemainingSyncMutation$variables = {
  input: changeJiraRemainingSyncInput;
};
export type ChangeJiraRemainingSyncMutation$data = {
  readonly changeJiraRemainingSync: {
    readonly project: {
      readonly remainingAutoCalculated: boolean | null;
      readonly jiraSyncRemaining: boolean | null;
      readonly jiraCloudProjectSettings: {
        readonly isSyncDone: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type ChangeJiraRemainingSyncMutation = {
  variables: ChangeJiraRemainingSyncMutation$variables;
  response: ChangeJiraRemainingSyncMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingAutoCalculated",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraSyncRemaining",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSyncDone",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeJiraRemainingSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "changeJiraRemainingSyncPayload",
        "kind": "LinkedField",
        "name": "changeJiraRemainingSync",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangeJiraRemainingSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "changeJiraRemainingSyncPayload",
        "kind": "LinkedField",
        "name": "changeJiraRemainingSync",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "18fc3e0836ec253e7237dd4a4bab64a8",
    "id": null,
    "metadata": {},
    "name": "ChangeJiraRemainingSyncMutation",
    "operationKind": "mutation",
    "text": "mutation ChangeJiraRemainingSyncMutation(\n  $input: changeJiraRemainingSyncInput!\n) {\n  changeJiraRemainingSync(input: $input) {\n    project {\n      remainingAutoCalculated\n      jiraSyncRemaining\n      jiraCloudProjectSettings {\n        isSyncDone\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f66cf54193cca593883fa9c85993b6a";

export default node;
